import { TourScope } from '../types';

/**
 * Build a route-scope predicate from a glob-ish pattern.
 * `*` matches within a path segment, `**` matches across segments.
 * e.g. route('/h/*') matches '/h/toronto-zoo'.
 */
export const route = (pattern: string): TourScope => {
  const regex = new RegExp(
    `^${pattern
      .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
      .replace(/\*\*/g, '::GLOBSTAR::')
      .replace(/\*/g, '[^/]*')
      .replace(/::GLOBSTAR::/g, '.*')}/?$`,
  );
  return (pathname: string) => regex.test(pathname);
};

export const isEligibleOnRoute = (scope: TourScope, pathname: string): boolean =>
  scope === 'global' ? true : scope(pathname);

// Compiled patterns are reused — the same handful of `when` values are matched every render.
const patternCache = new Map<string, (pathname: string) => boolean>();

/** Does `pathname` match a glob-ish `when` pattern? Used to pick path-varied ui configs. */
export const matchesPath = (pattern: string, pathname: string): boolean => {
  let predicate = patternCache.get(pattern);
  if (!predicate) {
    predicate = route(pattern) as (p: string) => boolean;
    patternCache.set(pattern, predicate);
  }
  return predicate(pathname);
};
